import { DataServiceSourcesCountSubscription } from "../../graphql/generated/operations";

/**
 * @param {DataServiceSourcesCountSubscription | undefined} data
 * @returns {number | undefined}
 */
export const formatter = (data) => data?.dataSourcesAggregate.aggregate?.count;
